import { createSlice } from "@reduxjs/toolkit";

const driversSlice = createSlice({
  name: "driversSlice",
  initialState: {
    items: [],
    options: [],
  },
  reducers: {
    populateData(state, action) {
      state.items = action.payload;
    },
    populateOptions(state, action) {
      const activeDrivers = action.payload.filter((d) => d.active);
      state.options = activeDrivers.map((d) => ({
        label: `${d.name} ${d.surname}`,
        value: d.id,
      }));
    },
  },
});

export const sliceActions = driversSlice.actions;

export default driversSlice.reducer;
